export default "__VITE_ASSET__e932b8ed__"